/**
 * Banner: großes Bild per CSS einblenden (opacity), sobald es geladen ist (.is-loaded).
 */
export function bannerMediaImageReveal() {
	document.querySelectorAll('.banner__media__image').forEach((img) => {
		if (img.dataset.bannerRevealBound) {
			return
		}
		img.dataset.bannerRevealBound = '1'

		const reveal = () => {
			img.classList.add('is-loaded')
		}

		if (img.complete && img.naturalWidth) {
			reveal()
		} else {
			img.addEventListener('load', reveal, { once: true })
			img.addEventListener('error', reveal, { once: true })
		}
	})
}
